<section class="ppp-overview" *ngIf="vm$ | async as vm">
  <header class="ppp-overview__header">
    <div>
      <h1>Preferred Partner Program</h1>
      <p class="ppp-overview__subtitle" *ngIf="vm.currentWeek as cw">
        Current week: {{ cw.weekStart }} → {{ cw.weekEnd }}
      </p>
    </div>
  </header>

  <ng-container *ngIf="vm.summary as summary; else loadingTpl">
    <div class="ppp-overview__regions" *ngIf="summary.byRegion?.length; else noRegionsTpl">
      <article
        class="ppp-region-card"
        *ngFor="let region of summary.byRegion; trackBy: trackByRegionId"
        [class.ppp-region-card--gray]="!region.inAllowlist"
      >
        <div class="ppp-region-card__title-row">
          <h2>{{ region.regionName }}</h2>
          <lohi-eligibility-status-chip
            [eligible]="region.carrierEligible"
            [inAllowlist]="region.inAllowlist"
          ></lohi-eligibility-status-chip>
        </div>
        <p class="ppp-region-card__reason">{{ region.reason | carrierReason }}</p>

        <div class="ppp-region-card__metrics">
          <div>
            <span class="ppp-region-card__metric-value">{{ region.totalBonusCents | centsToDollars }}</span>
            <span class="ppp-region-card__metric-label">Bonus this week</span>
          </div>
          <div>
            <span class="ppp-region-card__metric-value">{{ region.driversEligibleAtClose }}</span>
            <span class="ppp-region-card__metric-label">Drivers eligible</span>
          </div>
          <div>
            <span class="ppp-region-card__metric-value">{{ region.shiftsEvaluated }}</span>
            <span class="ppp-region-card__metric-label">Shifts evaluated</span>
          </div>
        </div>

        <p class="ppp-region-card__note" *ngIf="!region.inAllowlist">
          This region is not in the program yet. <a routerLink="rules">Learn more</a>
        </p>
        <p class="ppp-region-card__note" *ngIf="region.inAllowlist && region.carrierEligible === null">
          Pending evaluation. The Monday cron has not stamped a verdict yet.
        </p>
      </article>
    </div>
  </ng-container>

  <section class="ppp-overview__history">
    <h2>Past weeks</h2>
    <p class="ppp-overview__history-hint">Click any row to inspect the rule breakdown.</p>

    <table mat-table [dataSource]="vm.eligibility?.weeks || []" class="ppp-overview__table">
      <ng-container matColumnDef="weekStart">
        <th mat-header-cell *matHeaderCellDef>Week of</th>
        <td mat-cell *matCellDef="let week">{{ week.weekStart }}</td>
      </ng-container>

      <ng-container matColumnDef="region">
        <th mat-header-cell *matHeaderCellDef>Region</th>
        <td mat-cell *matCellDef="let week">{{ week.regionName }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let week">
          <lohi-eligibility-status-chip [eligible]="week.carrierEligible" size="sm"></lohi-eligibility-status-chip>
        </td>
      </ng-container>

      <ng-container matColumnDef="override">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let week">
          <span class="ppp-overview__override-pill" *ngIf="week.override"> <mat-icon>flag</mat-icon> Override </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['weekStart', 'region', 'status', 'override']"></tr>
      <tr
        mat-row
        *matRowDef="let week; columns: ['weekStart', 'region', 'status', 'override']; trackBy: trackByWeekId"
        class="ppp-overview__row"
        (click)="openWeek(week)"
      ></tr>
    </table>

    <p *ngIf="!vm.eligibility?.weeks?.length" class="ppp-overview__empty">No weekly evaluations yet.</p>
  </section>
</section>

<ng-template #loadingTpl>
  <div class="ppp-overview__loading">Loading summary…</div>
</ng-template>

<ng-template #noRegionsTpl>
  <div class="ppp-overview__loading">No regions are currently being evaluated for this carrier.</div>
</ng-template>
